import homePost2 from '../assets/images/home-post-2.png';

const post = {
    title: `Road Trip: On the <br> trail with Ok Motels`,
    slug: 'road-trip-on-the-trail-with-ok-motels',
    author: 'Nick Roberts',
    theme: 'light',
    image: 'https://images.unsplash.com/photo-1534373970208-f3cfd42788c0?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=dc9019dafb70ef5cedc47e360f920e34&auto=format&fit=crop&w=2100&q=80',
    dateCreated: 1534484858,
    categories: [
        {
            slug: 'beach',
            title: 'Beach'
        },
        {
            slug: 'places',
            title: 'Places'
        }
    ]
}

export const data = {
    featured: {
        ...post
    },
    posts: [
        {
            ...post,
            slug: 'we-sit-down-with-one-of-the-greats',
        },
        {
            ...post,
            slug: 'the-top-spots-for-music-in-byron',
            image: homePost2
        },
        {
            ...post,
            image: 'https://images.unsplash.com/photo-1534701369556-86a6f65c6398?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=f8df2bf91313fddc05972eea9f61e5e7&auto=format&fit=crop&w=2737&q=80'
        },
        ...post,
        {
            ...post,
            image: 'https://images.unsplash.com/photo-1534694895098-4b226f923532?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=1eab6d18c74a9f748a912374780ac548&auto=format&fit=crop&w=1534&q=80'
        },
        {
            ...post,
            image: 'https://images.unsplash.com/photo-1534701369556-86a6f65c6398?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=f8df2bf91313fddc05972eea9f61e5e7&auto=format&fit=crop&w=2737&q=80'
        },
        {
            ...post
        },
    ],
    categories: [
        {
            slug: 'beach', 
            name: 'Beach'
        },
        {
            slug: 'art', 
            name: 'Art'
        },
        {
            slug: 'stuff', 
            name: 'Stuff'
        }
    ]
}


// WEBPACK FOOTER //
// ./src/data/home.js